import type { CatalogJobListItem } from '@tabbio/types';

/** AI form filling is available only for a catalog job whose selected source is an ATS. */
export function supportsCatalogAtsAiApply(
  job: Pick<CatalogJobListItem, 'source' | 'sourceInfo' | 'isExternal'> | null | undefined,
): boolean {
  if (!job?.isExternal || job.source !== job.sourceInfo?.key) return false;
  return job.source === 'partner_ats' || job.source === 'ats_workable';
}
